function isDefined(arg) {
  return arg !== undefined && arg !== null;
}

export { isDefined };
